import React from 'react';
import { Modifier } from '../../../lib/bemUtils/Modifier';
import extendClassName from '../../../lib/bemUtils/bem';

type TextBubbleProps = {
  content?: string;
  type?: string;
  modifier?: Modifier<'margin-bottom'>;
};

export default function TextBubble({ content, type, modifier }: TextBubbleProps) {
  if (!content) {
    return null;
  }

  return (
    <p className={extendClassName('text-bubble', modifier)}>
      {type && <dfn className="invisible">{type}: </dfn>}
      <span className="text-bubble__text">&bdquo;{content}&ldquo;</span>
    </p>
  );
}
